import React, { Component } from 'react';
import Content from './Content';
import { Constants, ModelManager } from '@adobe/cq-spa-page-model-manager';
import { connect } from 'react-redux';
import { modalActions } from '../../redux/root-action';

interface Props {
  pageUrl: string;
}

class ContentModalWrapper extends Component<Props> {
  props: any;

  componentDidMount() {
    const { pageUrl, setModalContent } = this.props;
    ModelManager.initialize({ path: pageUrl }).then((pageModel: any) => {
      setModalContent(pageModel);
    });

    // ModelManager.getData(pageUrl).then((pageModel: any) => {
    //   setModalContent(pageModel);
    // });
  }

  render(): any {
    const { pageModel } = this.props;
    return (
      <div>
        {pageModel && (
          <Content
            cqChildren={pageModel[Constants.CHILDREN_PROP]}
            cqItems={pageModel[Constants.ITEMS_PROP]}
            cqItemsOrder={pageModel[Constants.ITEMS_ORDER_PROP]}
            cqPath={pageModel[Constants.PATH_PROP]}
            locationPathname={window.location.pathname}
          />
        )}
      </div>
    );
  }
}

const mapStateToProps = ({ modal }: any) => {
  return {
    pageModel: modal.pageModel,
  };
};
export default connect(mapStateToProps, { setModalContent: modalActions.setModalContent })(ContentModalWrapper);
